export default __webpack_public_path__ + "static/media/59.919f94d9.jpg";